import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';

const Visual = ({ children, style = {} }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <div style={{ width: '100%', ...style }}>
      {children}
      <Button
        icon={<ExpandAltOutlined />}
        size='large'
        onClick={() => setIsModalVisible(true)}
        style={{
          cursor: 'pointer',
          fontSize: '16px',
          position: 'absolute',
          top: '8px',
          right: '8px'
        }}
      />

      <Modal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="100%"
        style={{ top: 0, padding: 0 }}
        bodyStyle={{ padding: '24px', height: '100vh', overflow: 'auto' }}
      >
        {children}
      </Modal>
    </div>
  );
};

export default Visual; 